import { helper } from "src/utils/helper";

interface HighlightProps {
  fullString: string; // Bu bir deneme mesajidir
  matchString: string; // deneme
}


const Highlight = (props: HighlightProps):JSX.Element => {

  let fs = props.fullString;
  let ms = props.matchString;

  if(!ms)
    return (
      <div>
        <span
          style={{
            fontWeight: 400,
          }}
        >
          {fs}
        </span>
      </div>
    )
  let msAsc = helper.UpperCaseAsc(ms);

  let res = [];
  
  while (true) {
    let fsAsc = helper.UpperCaseAsc(fs);
    let index = fsAsc.search(msAsc);
    if(index == -1){
      if(fs.length > 1)
        res.push({
          highlight: false,
          val: fs
        });
      break;
    }

    if(index == 0) {
      res.push({
        highlight: true,
        val: fs.slice(0, msAsc.length)
      });
      fs = fs.slice(msAsc.length);
    }
    else {
      res.push({
        highlight: false,
        val: fs.slice(0, index)
      });
      fs = fs.slice(index);
    }

  }
  
  return (
    <div>
      {res.map(r =>
        <span
          style={{
            fontWeight: r.highlight ? 700 : 400,
          }}
        >
          {r.val}
        </span>
      )}
    </div>
  )
  // return <div>{props.fullString}</div>
}

export default Highlight;
